import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {
    message,
    Breadcrumb,
    Space,
    Button,
    Form,
    Row,
    Col,
    Input,
    Table,
    Select,
    Tag,
    DatePicker,
    Modal
} from "antd";
import {
    CloseCircleOutlined,CheckOutlined,
    CloudDownloadOutlined, DeleteOutlined,
    FileAddOutlined, FileDoneOutlined,
    FileSearchOutlined,
    HddOutlined
} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const GoodsIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(store.main.pageSize);
    const [couponIdList, setCouponIdList] = useState([]); // 选中列表
    const [couponTotal, setCouponTotal] = useState(0);
    const [couponList, setCouponList] = useState([]);
    const [activityList,setActivityList] = useState([]);
    const [visibleEpTime,setVisibleEpTime] = useState(false);// 延期
    const [epForm] = Form.useForm();

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/coupon/index"});
            handleLoadActivity();
            handleSearch();
        }
        //eslint-disable-next-line
    }, [store.main.userName]);

    useEffect(() => {
        handleLoad(pageIndex, store.main.pageSize);

        //eslint-disable-next-line
    }, [store.main.pageSize]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoad(pageIndex, pageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleLoadActivity = () => {
        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/activity/business/website/v1/select/list",
            data: {},
            success: (response) => {
                setActivityList(response.data);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {},
        });
    };

    const handleSearch = () => {
        handleLoad(1, pageSize);
    };

    const handleLoad = (pageIndex, pageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;
        setIsLoad(true);

        let data = form.getFieldsValue();
        if (data.epTimes.length===2){
            data.epTimeBeg = (data.epTimes[0]).format("YYYYMMDDHHmmss")
            data.epTimeEnd = (data.epTimes[1]).format("YYYYMMDDHHmmss")
            delete data.epTimes;
        }
        data.pageIndex = pageIndex;
        data.pageSize = pageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/coupon/business/website/v1/list",
            data: data,
            success: (response) => {
                setPageIndex(pageIndex);
                setPageSize(pageSize);
                setCouponIdList([]);
                setCouponTotal(response.data.total);
                setCouponList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;
                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                    response.data.total == "undefined" ||
                    response.data.total == null ||
                    response.data.list == "undefined" ||
                    response.data.list == null
                );
            },
        });
    };

    const handleAdd = () => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/coupon/add",
        });
    };

    const handleChangeIdList = (IdList) => {
        setCouponIdList(IdList);
    };

    const handleChangePagination = (pageIndex, pageSize) => {
        handleLoad(pageIndex, pageSize);
    };

    // 导出
    const handleExport = () => {
        let len = couponIdList.length;
        let content = "";
        if (len>0){
            content = `是否确认导出选中的 ${len} 个优惠券`
        }else if (couponTotal>0) {
            content = `是否确认导出查询结果的 ${couponTotal} 个优惠券`
        }
        if (!content){
            message.warn({content: "没有可导出的优惠券", duration: 2});
            return;
        }

        Modal.confirm({
            title: "导出优惠券",
            content: content,
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <CheckOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;
                setIsLoad(true);

                message.loading({content: "正在加载", key: "isLoad", duration: 0});

                let data = form.getFieldsValue();
                data.pageIndex = 0;
                data.pageSize = 0;
                if (couponIdList.length>0){
                    data.codes = couponIdList.join(",")
                }
                ChuangShiOS.Util.download(this, {
                    url: Application.host + "/windeal/coupon/business/website/v1/export",
                    data: data,
                    success: (response) => {
                        message.success("导出成功",2);
                    },
                    error: (response) => {
                        message.error({content: response.message, duration: 1});
                    },
                    complete: (response) => {
                        request.current = false;
                        setIsLoad(false);
                        message.destroy("isLoad")
                    }
                });
            },
        });
    };

    // 作废优惠券
    const handleInvalid = ()=>{
        if(couponIdList.length===0){
            message.warn({content: "请选择需要作废的券", duration: 2});
            return
        }
        Modal.confirm({
            title: "确认作废优惠券？",
            content: "本次数据操作后将无法恢复",
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <DeleteOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;
                setIsLoad(true);
                message.loading({content: "正在加载", key: "isLoad", duration: 0});
                ChuangShiOS.Util.request(this, {
                    url: Application.host + "/windeal/coupon/business/website/v1/invalid",
                    data: {code:couponIdList.join(",")},
                    success: (response) => {
                        request.current = false;
                        handleSearch()
                        message.success("作废成功",3);
                    },
                    error: (response) => {
                        message.error({content: response.message, duration: 2});
                    },
                    complete: (response) => {
                        message.destroy("isLoad")
                        request.current = false;
                        setIsLoad(false);
                    }
                });
            },
        });
    }

    // 延期优惠券
    const handleSubmitEpTime = ()=>{
        if(couponIdList.length===0){
            message.warn({content: "请选择需要延期的券", duration: 2});
            return
        }
        let epTime = epForm.getFieldValue('epTime');
        if (!epTime){
            message.warn({content: "延期时间不能为空", duration: 2});
            return
        }
        epTime = epTime.format("YYYYMMDDHHmmss")

        if (request.current) {
            return;
        }
        request.current = true;
        setIsLoad(true);
        message.loading({content: "正在加载", key: "isLoad", duration: 0});
        ChuangShiOS.Util.request(this, {
            url: Application.host + "/windeal/coupon/business/website/v1/seteptime",
            data: {code:couponIdList.join(","),epTime},
            success: (response) => {
                request.current = false;
                handleSearch()
                message.success("延期成功",3)
                setVisibleEpTime(false)
            },
            error: (response) => {
                message.error({content: response.message, duration: 2});
            },
            complete: (response) => {
                message.destroy("isLoad")
                request.current = false;
                setIsLoad(false);
            }
        });
    }
    const handleCancelEpTime = ()=>{
        setVisibleEpTime(false)
    }

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button icon={<FileAddOutlined />} size="large" onClick={handleAdd}>
                            新增
                        </Button>
                        <Button.Group>
                            <Button icon={<HddOutlined />} size="large" onClick={()=>{
                                if(couponIdList.length===0){
                                    message.warn({content: "请选择需要延期的券", duration: 2});
                                    return
                                }
                                setVisibleEpTime(true);
                            }}>延期</Button>
                            <Button icon={<HddOutlined />} size="large" onClick={handleInvalid}>作废</Button>
                            <Button loading={isLoad} icon={<CloudDownloadOutlined />} size="large" onClick={handleExport}>导出</Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined />} type="primary" size="large" onClick={handleSearch}>查询</Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError} isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="采购活动"
                                labelAlign={"left"}
                                name="activityId"
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入商户名称",
                                    },
                                ]}>
                                <Select
                                    className={Style.card_field}
                                    placeholder="请选择活动"
                                    allowClear>
                                    {activityList.map((activity, activityIndex) => {
                                        return (
                                            <Select.Option key={activityIndex} value={activity.activityId}>
                                                {activity.activityName}
                                            </Select.Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="优惠券名称"
                                labelAlign={"left"}
                                name="couponName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入优惠券名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入券码" onPressEnter={handleSearch} allowClear/>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="优惠券码"
                                labelAlign={"left"}
                                name="code"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入券码",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入券码" onPressEnter={handleSearch} allowClear />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="券码状态"
                                labelAlign={"left"}
                                name="status"
                                rules={[{
                                        required: false,
                                        message: "请选择状态",
                                    },
                                ]}
                            >
                                <Select
                                    className={Style.card_field}
                                    placeholder="请选择状态"
                                    allowClear>
                                    <Select.Option value={"S1"}>待兑换</Select.Option>
                                    <Select.Option value={"S2"}>待核销</Select.Option>
                                    <Select.Option value={"S30"}>部分核销</Select.Option>
                                    <Select.Option value={"S3"}>已核销</Select.Option>
                                    <Select.Option value={"S4"}>已作废</Select.Option>
                                    <Select.Option value={"S5"}>已过期</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="会员手机"
                                labelAlign={"left"}
                                name="tel"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入会员手机号",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入会员手机号" onPressEnter={handleSearch} allowClear/>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="会员姓名"
                                labelAlign={"left"}
                                name="memberName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入会员名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入会员名称" onPressEnter={handleSearch} allowClear/>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="关联订单"
                                labelAlign={"left"}
                                name="txdOrderId"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入关联订单号",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入关联订单号" onPressEnter={handleSearch} allowClear />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="券过期时间"
                                labelAlign={"left"}
                                name="epTimes"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入关联订单号",
                                    },
                                ]}
                            >
                                <DatePicker.RangePicker showTime  style={{width:"95%"}}/>
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.code}
                        columns={[
                            {
                                title: "采购商活动",
                                width: 200,
                                dataIndex: "activityName",
                            },
                            {
                                title: "优惠券名称",
                                width: 180,
                                dataIndex: "goodsName",
                                render:(value, record, index)=>(
                                    <React.Fragment>
                                        <div>{record.couponName}</div>
                                        <div className={Style.id}>ID:{record.couponId}</div>
                                    </React.Fragment>
                                )
                            },
                            {
                                title: "优惠券券码",
                                width: 120,
                                dataIndex: "code",
                            },
                            {
                                title: "券面值",
                                width: 170,
                                render: (text, record, recordIndex) => (
                                    <React.Fragment>
                                        <div>{record.type==="T1"?"兑换券":null}</div>
                                        <div>{record.type==="T2" && record.faceValue >0 ?`满减券 满${record.fullValue}元 减${record.faceValue}元 ${record.balanceFlag?'剩'+record.balance+'元':''}`:null}</div>
                                        <div>{record.type==="T2" && record.facePoints >0 ?`满减券 满${record.fullPoints}点 减${record.facePoints}点 ${record.balanceFlag?'剩'+record.balancePoints+'点':''}`:null}</div>
                                        <div>{record.type==="T3"?`满折券 满${record.fullValue}元 打${record.discountRate}折`:null}</div>
                                    </React.Fragment>
                                ),
                            },
                            {
                                title: "券码状态",
                                width: 110,
                                dataIndex: "statusLabel",
                                render:(text, record, recordIndex)=>(<Tag>{text}</Tag>)
                            },
                            {
                                title: "有效期",
                                width: 360,
                                render: (text, record, recordIndex) => (
                                    <React.Fragment>
                                        <div>{record.ebTime}~{record.epTime}</div>
                                        <div>
                                            {record.exType==='E1'?'有效期内，任意时段可用':''}
                                            {record.exType==='E2'?`有效期内，领取后${record.exDays}天可用`:''}
                                        </div>
                                    </React.Fragment>
                                ),
                            },
                            {
                                title: "优惠券介绍",
                                width: 200,
                                dataIndex: "explain",
                            },
                            {
                                title: "兑换时间/核销时间",
                                width: 180,
                                render: (text, record, recordIndex) => (
                                    <React.Fragment>
                                        <div>{record.excTime?record.excTime:"未"}兑换</div>
                                        <div>{record.useTime?record.useTime:"未"}核销</div>
                                    </React.Fragment>
                                ),
                            },
                            {
                                title: "兑换关联用户",
                                width: 120,
                                render: (text, record, recordIndex) => (
                                    <React.Fragment>
                                        <div>{record.memberName}</div>
                                        <div>{record.tel}</div>
                                    </React.Fragment>
                                ),
                            },
                            {
                                title: "核销关联订单",
                                width: 170,
                                dataIndex: "txdOrderId",
                            }
                        ]}
                        dataSource={couponList}
                        rowSelection={{
                            fixed: true,
                            selectedRowKeys: couponIdList,
                            onChange: handleChangeIdList,
                        }}
                        /*scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}*/
                        scroll={store.main.isFixedContent ? {x: 2000, y: tableHeight - 120} : {x: 2000}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: pageIndex,
                            pageSize: pageSize,
                            total: couponTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangePagination,
                            onShowSizeChange: handleChangePagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>

            {/* 优惠券延期 */}
            <Modal
                title="优惠券延期"
                open={visibleEpTime}
                centered
                width={ChuangShiOS.Util.getModalWidth()}
                bodyStyle={{backgroundColor: "#eff3f8", padding: "20px"}}
                cancelButtonProps={{icon: <CloseCircleOutlined />, size: "large",}}
                okButtonProps={{icon: <FileDoneOutlined />, size: "large"}}
                onCancel={handleCancelEpTime}
                onOk={handleSubmitEpTime}
                footer={
                    <div className={Style.footer}>
                        <div className={Style.footer_space}></div>
                        <Space>
                            <Button icon={<CloseCircleOutlined />} size="large" onClick={handleCancelEpTime}>
                                取消
                            </Button>
                            <Button icon={<FileDoneOutlined />} type="primary" size="large" onClick={handleSubmitEpTime}>
                                提交
                            </Button>
                        </Space>
                    </div>
                }
            >
                <div style={{height: ChuangShiOS.Util.getModalHeight() + "px"}} className={Style.page}>
                    <ChuangShiOS.Content
                        className={Style.content}
                        isLoad={isLoad}
                        isEmpty={false}
                        isError={false}
                        marginLeft={0}
                        marginRight={0}
                        paddingTop={0}
                        paddingRight={0}
                        paddingBottom={0}
                        paddingLeft={0}
                    >
                        <div className={Style.main}>
                            <Form form={epForm}>
                                <Row><Col>&nbsp;</Col></Row>
                                <Row><Col>&nbsp;</Col></Row>
                                <Row><Col>&nbsp;</Col></Row>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item
                                            {...{
                                                labelCol: {flex: "24%"},
                                                wrapperCol: {flex: "auto"},
                                            }}
                                            label="截止时间"
                                            name="epTime"
                                            rules={[{required: true, message: "请输入截止时间"}]}
                                        >
                                            <DatePicker showTime/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </ChuangShiOS.Content>
                </div>
            </Modal>
        </div>
    );
};

GoodsIndex.propTypes = {};

GoodsIndex.defaultProps = {};

export default GoodsIndex;
